import { Component, OnInit, ChangeDetectorRef, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { UserService } from 'src/app/user.service';
import { Router, RouterOutlet } from '@angular/router';
import { Utils } from 'src/app/utils';
import { routePageSlideInOutAnimation } from 'src/app/shared/animations';
import { ConfigService } from 'src/app/config.service';

@Component({
  selector: 'file360-standard-layout',
  templateUrl: './standard-layout.component.html',
  styleUrls: ['./standard-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    routePageSlideInOutAnimation
  ]
})
export class StandardLayoutComponent implements OnInit, OnDestroy {

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  helpUrl: string = "";

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,
    public userService: UserService, private router: Router,
    public configService: ConfigService) {
    this.mobileQuery = media.matchMedia(Utils.isMobileMediaQuery());
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    //
    // When help URL changes, update the help link
    //
    this.configService.helpUrl.subscribe(help => {
      this.helpUrl = help;
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  logOff() {
    this.userService.logOff();
    this.router.navigate(['/']);
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
